import { ProfileDetailsType } from "./ProfileDetailsType"

export type CommercialFlagType = Pick<ProfileDetailsType, "hasCommercialFlag">

export const initialCommercialFlag: CommercialFlagType = {
  hasCommercialFlag: null // not false as it will remove tenants on snapshot
}

export const keysOfCommercialFlagType: (keyof CommercialFlagType)[] = [
  "hasCommercialFlag",
];